var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useAuth from '../../App/hooks/useAuth';
import PromotionBanner from '../components/PromotionBanner';
import ProviderGoals from '../components/ProviderGoals';
import ProviderActivity from '../components/ProviderActivity';
import { customerEmployeeRole, customerRole, } from '../../App/helpers/RoleHelper';
import HomeAdmin from './HomeAdmin';
import CouponUI from '../../App/components/CouponUI';
import Shortcuts from '../components/Shortcuts';
function Home() {
    var auth = useAuth().auth;
    return (_jsx("div", __assign({ style: { padding: '3.2% 6.35%' } }, { children: auth.role_id === customerRole ||
            auth.role_id === customerEmployeeRole ? (_jsxs(_Fragment, { children: [_jsx(PromotionBanner, {}), _jsx(Shortcuts, {}), _jsx(ProviderGoals, {}), _jsx(ProviderActivity, {}), _jsx(CouponUI, {})] })) : (_jsx(HomeAdmin, {})) })));
}
export default Home;
